export default "__VITE_ASSET__Ba2Vss_w__"